import Utils from "../../services/utils";

export const getChatUrl = ({url, Auth, window}) => {
  const urlWithoutLang = url.replace(/&lang=[a-z]{2}/, '').replace(/&theme=(sfr|catsafe)/, '');
  const lang = window.V.$localStorage.get('BPZ_' + Auth.getHash() + '_LOCALE')
  return urlWithoutLang + 
    '&userid=' + Auth.user.iduser + 
    '&username=' + Auth.user.name + 
    '&lang=' + lang +
    '&theme=' + Utils.getThemeName()      ;
}